/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Signer_ApproverInputs */

const vi_sinp_signer_approver = /** @type {(inputs: Sinp_Signer_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NGƯỜI DUYỆT`)
};

/**

* @param {Sinp_Signer_ApproverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_signer_approver = /** @type {((inputs?: Sinp_Signer_ApproverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Signer_ApproverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_signer_approver(inputs)
});